import { useEffect, useRef } from "react";
import { gsap, prefersReducedMotion } from "../lib/motion";
import landingOverlay from "../assets/decor/landing-overlay.webp";
import "./Dune.css";

/**
 * The desert-dune wipe that carries the dark hero into the white page body.
 * On the reference this is a 700px section pulled 675px up over the hero; we
 * keep that geometry and add a slow scrub so the dune "rises" as you scroll.
 */
export default function Dune() {
  const rootRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        layerRef.current,
        { yPercent: 9, scale: 1.06 },
        {
          yPercent: 0,
          scale: 1,
          ease: "none",
          scrollTrigger: {
            trigger: rootRef.current,
            start: "top bottom",
            end: "bottom center",
            scrub: 0.8,
          },
        }
      );
    }, rootRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="dune" ref={rootRef} aria-hidden="true">
      <div
        className="dune__layer"
        ref={layerRef}
        style={{ backgroundImage: `url(${landingOverlay})` }}
      />
    </div>
  );
}
